import { render, staticRenderFns } from "./ItemPriceHistoryList.vue?vue&type=template&id=16ea6890"
import script from "./ItemPriceHistoryList.vue?vue&type=script&lang=js"
export * from "./ItemPriceHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports